const marketTestPlans = [
    {
        "uuid": "1",
        "year": 2021,
        "marketTestNumber": 3,
        "createdOn": "2021-01-01",
        "creator": "陳小明",
        "sendingDate": "2021-02-15",
        "marketTestList": [
            {
                "season": "Q1",
                "customer": "中農粉絲有限公司",
                "assessmentPlace": "宜蘭廠",
                "selectOrEnter": "select",
                "selectProductName": "01",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany": "sgs",
                "paymentUnit": "tseyue"
            },
            {
                "season": "Q1",
                "customer": "源天然股份有限公司",
                "assessmentPlace": "花蓮廠",
                "selectOrEnter": "select",
                "selectProductName": "02",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany": "intertek",
                "paymentUnit": "leezen"
            },
            {
                "season": "Q1",
                "customer": "豆之家食品有限公司",
                "assessmentPlace": "台東廠",
                "selectOrEnter": "select",
                "selectProductName": "03",
                "testItems":[{testItem:"09", details:["0901", "0903"]},{testItem:"10", details:["1002","1004"]}],
                "testCompany": "sgs",
                "paymentUnit": "tseyue"
            },
        ],
    },
    {
        "uuid": "2",
        "year": 2021,
        "marketTestNumber": 3,
        "createdOn": "2021-04-01",
        "creator": "蔡小草",
        "sendingDate": "2021-05-15",
        "marketTestList": [
            {
                "season": "Q2",
                "customer": "中農粉絲有限公司",
                "assessmentPlace": "宜蘭廠",
                "selectOrEnter": "select",
                "selectProductName": "01",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany": "sgs",
                "paymentUnit": "tseyue"
            },
            {
                "season": "Q2",
                "customer": "源天然股份有限公司",
                "assessmentPlace": "花蓮廠",
                "selectOrEnter": "select",
                "selectProductName": "02",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany": "intertek",
                "paymentUnit": "leezen"
            },
            {
                "season": "Q2",
                "customer": "豆之家食品有限公司",
                "assessmentPlace": "台東廠",
                "selectOrEnter": "select",
                "selectProductName": "03",
                "testItems":[{testItem:"09", details:["0901", "0903"]},{testItem:"10", details:["1002","1004"]}],
                "testCompany": "sgs",
                "paymentUnit": "tseyue"
            },
        ],
    },
    {
        "uuid": "3",
        "year": 2021,
        "marketTestNumber": 3,
        "createdOn": "2021-07-01",
        "creator": "馮小馬",
        "sendingDate": "2021-08-15",
        "marketTestList": [
            {
                "season": "Q3",
                "customer": "中農粉絲有限公司",
                "assessmentPlace": "宜蘭廠",
                "selectOrEnter": "select",
                "selectProductName": "01",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany": "sgs",
                "paymentUnit": "tseyue"
            },
            {
                "season": "Q3",
                "customer": "源天然股份有限公司",
                "assessmentPlace": "花蓮廠",
                "selectOrEnter": "select",
                "selectProductName": "02",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany": "intertek",
                "paymentUnit": "leezen"
            },
            {
                "season": "Q3",
                "customer": "豆之家食品有限公司",
                "assessmentPlace": "台東廠",
                "selectOrEnter": "select",
                "selectProductName": "03",
                "testItems":[{testItem:"09", details:["0901", "0903"]},{testItem:"10", details:["1002","1004"]}],
                "testCompany": "sgs",
                "paymentUnit": "tseyue"
            },
        ],
    },
    {
        "uuid": "4",
        "year": 2021,
        "marketTestNumber": 3,
        "createdOn": "2021-09-01",
        "creator": "黃小飛",
        "marketTestList": [
            {
                "season": "Q4",
                "customer": "中農粉絲有限公司",
                "assessmentPlace": "宜蘭廠",
                "selectOrEnter": "select",
                "selectProductName": "01",
                "testItems":[{testItem:"01"},{testItem:"02", details:["0201","0202"]}],
                "testCompany": "sgs",
                "paymentUnit": "tseyue"
            },
            {
                "season": "Q4",
                "customer": "源天然股份有限公司",
                "assessmentPlace": "花蓮廠",
                "selectOrEnter": "select",
                "selectProductName": "02",
                "testItems":[{testItem:"04", details:["0401"]},{testItem:"05", details:["0501","0502"]}],
                "testCompany": "intertek",
                "paymentUnit": "leezen"
            },
            {
                "season": "Q4",
                "customer": "豆之家食品有限公司",
                "assessmentPlace": "台東廠",
                "selectOrEnter": "select",
                "selectProductName": "03",
                "testItems":[{testItem:"09", details:["0901", "0903"]},{testItem:"10", details:["1002","1004"]}],
                "testCompany": "sgs",
                "paymentUnit": "tseyue"
            },
        ],
    },
]

export default marketTestPlans;